import { render, staticRenderFns } from "./CreatePlanStepOne.vue?vue&type=template&id=84152f28&scoped=true"
import script from "./CreatePlanStepOne.vue?vue&type=script&lang=js"
export * from "./CreatePlanStepOne.vue?vue&type=script&lang=js"
import style0 from "./CreatePlanStepOne.vue?vue&type=style&index=0&id=84152f28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84152f28",
  null
  
)

export default component.exports